import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MERCADERIA_SIN_ANALISIS } from '../../../../config/tables'

export default function MercaderiaSinAnalisisView () {
  return <MuiTable id={TABLA_MERCADERIA_SIN_ANALISIS} />
}
